import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b1b6dfd0")

_pushScopeId("data-v-b1b6dfd0")
const _hoisted_1 = { class: "common-horizontal-recipe-list-item-card" }
const _hoisted_2 = { class: "common-horizontal-recipe-list-item-card-image" }
const _hoisted_3 = { class: "common-horizontal-recipe-list-item-card-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "common-horizontal-recipe-list-item",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.recipeImageUrl)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "common-horizontal-recipe-list-item-card-image-image",
              src: _ctx.recipeImageUrl,
              style: _ctx.styleImage,
              onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
            }, null, 44, ["src"]))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              class: "common-horizontal-recipe-list-item-card-image-noimage",
              src: _ctx.noImage,
              style: _ctx.styleImage
            }, null, 12, ["src"]))
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          innerHTML: _ctx.recipeLabel,
          class: "commonTextCaption2 common-horizontal-recipe-list-item-card-title-text"
        }, null, 8, ["innerHTML"])
      ])
    ])
  ]))
})